import { cn } from '@mntn-dev/ui-utilities'
import type { UseFormFieldControlProps } from '../components/form-field/use-form-field-control.ts'

export const getInputStyles = <TElement extends HTMLElement>(
  {
    disabled,
    readOnly,
    hasError,
    hasSuccess,
    hasWarning,
  }: Pick<
    UseFormFieldControlProps<TElement>,
    'disabled' | 'hasError' | 'hasSuccess' | 'hasWarning' | 'readOnly'
  >,
  isNonInteractiveNode = false
) => {
  return cn('input-base', {
    'border-positive focus:border-positive': hasSuccess,
    'border-negative focus:border-negative': hasError,
    'border-caution focus:border-caution': hasWarning,
    'shadow-elevation-xs': !(disabled || readOnly),
    'border-control-disabled hover:border-control-disabled text-disabled placeholder:invisible':
      isNonInteractiveNode && disabled,
    'border-control-readonly hover:border-control-readonly placeholder:invisible':
      isNonInteractiveNode && readOnly,
  })
}
